import React from 'react';
import { motion } from 'framer-motion';
import { SectionHeading } from '../ui/SectionHeading';
import { Gift, Calculator, BrainCircuit } from 'lucide-react';
export function BonusesSection() {
  return <section className="py-24 bg-dark text-white relative overflow-hidden" data-id="element-45">
      {/* Background pattern */}
      <div className="absolute inset-0 opacity-5" style={{
      backgroundImage: 'radial-gradient(#C9A96E 2px, transparent 2px)',
      backgroundSize: '30px 30px'
    }} data-id="element-46"></div>

      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-47">
        <div className="text-center mb-16" data-id="element-48">
          <motion.div animate={{
          rotate: [0, 10, -10, 0]
        }} transition={{
          duration: 2,
          repeat: Infinity,
          ease: 'easeInOut'
        }} className="inline-block mb-4" data-id="element-49">
            <Gift className="w-16 h-16 text-gold-400" data-id="element-50" />
          </motion.div>
          <SectionHeading title="Bonos Gratis (Oferta Especial)" subtitle="Además, hoy recibís 2 bonos exclusivos totalmente gratis:" light={true} data-id="element-51" />
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-16" data-id="element-52">
          {/* Bonus 1 */}
          <motion.div className="bg-gradient-to-br from-white/10 to-white/5 border border-gold-500/30 rounded-3xl p-8 relative overflow-hidden backdrop-blur-sm" initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} data-id="element-53">
            <div className="absolute top-0 right-0 bg-gold-500 text-dark text-xs font-bold px-4 py-1 rounded-bl-xl uppercase tracking-wider" data-id="element-54">
              Bono 1
            </div>
            <div className="bg-gold-500/20 w-16 h-16 rounded-2xl flex items-center justify-center mb-6 border border-gold-500/30" data-id="element-55">
              <Calculator className="w-8 h-8 text-gold-400" data-id="element-56" />
            </div>
            <h3 className="text-2xl font-playfair font-bold mb-4 text-gold-300" data-id="element-57">
              Calculadora de precios + guía de ganancias.
            </h3>
            <p className="text-gray-300" data-id="element-58">
              Asegurate de cobrar lo justo y tener rentabilidad desde el primer
              día sin complicaciones matemáticas.
            </p>
          </motion.div>

          {/* Bonus 2 */}
          <motion.div className="bg-gradient-to-br from-white/10 to-white/5 border border-gold-500/30 rounded-3xl p-8 relative overflow-hidden backdrop-blur-sm" initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} data-id="element-59">
            <div className="absolute top-0 right-0 bg-gold-500 text-dark text-xs font-bold px-4 py-1 rounded-bl-xl uppercase tracking-wider" data-id="element-60">
              Bono 2
            </div>
            <div className="bg-gold-500/20 w-16 h-16 rounded-2xl flex items-center justify-center mb-6 border border-gold-500/30" data-id="element-61">
              <BrainCircuit className="w-8 h-8 text-gold-400" data-id="element-62" />
            </div>
            <h3 className="text-2xl font-playfair font-bold mb-4 text-gold-300" data-id="element-63">
              7 secretos psicológicos que hacen que todos compren.
            </h3>
            <p className="text-gray-300" data-id="element-64">
              Técnicas probadas para vender tus servicios de manera natural y
              sin parecer desesperada por vender.
            </p>
          </motion.div>
        </div>

        <motion.div className="text-center" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} data-id="element-65">
          <p className="text-xl md:text-2xl font-playfair text-gold-100 italic" data-id="element-66">
            "Todo lo que necesitás para empezar sin gastar de más ni
            equivocarte."
          </p>
        </motion.div>
      </div>
    </section>;
}